/**
 * Colore e modalità di raccolta della delega (capitolato ottobre 2026, cap. 1).
 * Valgono per `deleghe` e `archivio`. Dati puri, usabili anche dal client.
 */
import { z } from 'zod';
import type { ElementoLista } from './lista-gestita.ts';

export const MODALITA_RACCOLTA = ['AGGIORNAMENTO', 'UFFICIO', 'GIRO_CANTIERE', 'ALTRO'] as const;
export const ModalitaRaccoltaSchema = z.enum(MODALITA_RACCOLTA);
export type ModalitaRaccolta = z.infer<typeof ModalitaRaccoltaSchema>;

export const MODALITA_RACCOLTA_LABEL: Record<ModalitaRaccolta, string> = {
  AGGIORNAMENTO: 'Aggiornamento',
  UFFICIO: 'Ufficio',
  GIRO_CANTIERE: 'Giro cantiere',
  ALTRO: 'Altro',
};

/** Valore del filtro `colore` che seleziona le righe senza colore (`colore_id IS NULL`) */
export const COLORE_NESSUNO = 'nessuno';

/** Elemento della lista `colori`: il css c'è sempre */
export type ColoreDelega = ElementoLista & { css: string };
